import { render, staticRenderFns } from "./all.vue?vue&type=template&id=36f5d22c&scoped=true"
import script from "./all.vue?vue&type=script&lang=js"
export * from "./all.vue?vue&type=script&lang=js"
import style0 from "./all.vue?vue&type=style&index=0&id=36f5d22c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f5d22c",
  null
  
)

export default component.exports